module.exports = __webpack_public_path__ + "static/main-57034cd359ea86dbdf99090c6ad6507e.jpg";